module.exports = __webpack_public_path__ + "static/media/pm.04fdef40.svg";